<script setup>
import TiptapEditor from "@/components/tiptap-editor/TiptapEditor.vue"
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object
})

const formStore = useFormStore(props.formId)

// Emulating the created hook logic
const initialContent = props.currentData?.[props.field.name]
if (typeof initialContent === 'undefined' || initialContent === null) {
    formStore.presetData({
        name: props.field.name,
        value: ''
    })
}
</script>

<template>
    <div>
        <!-- This is required for validation. It remains in the DOM and so can be validated -->
        <textarea :id="field.id" v-model="currentData[field.name]" :name="field.name" :required="field.required"
                  style="display: none"/>

        <TiptapEditor :formId="formId" v-model="props.currentData[props.field.name]"/>
    </div>
</template>